export default __webpack_public_path__ + "static/media/petard.99bc493f.png";